/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Item_Stats_Lowestprice1Inputs */

const he_item_stats_lowestprice1 = /** @type {(inputs: Item_Stats_Lowestprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המחיר הנמוך ביותר`)
};

const en_item_stats_lowestprice1 = /** @type {(inputs: Item_Stats_Lowestprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowest ever`)
};

/**
* | output |
* | --- |
* | "Lowest ever" |
*
* @param {Item_Stats_Lowestprice1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const item_stats_lowestprice1 = /** @type {((inputs?: Item_Stats_Lowestprice1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Stats_Lowestprice1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_item_stats_lowestprice1(inputs)
	return en_item_stats_lowestprice1(inputs)
});
export { item_stats_lowestprice1 as "item_stats_lowestPrice" }